export default "__VITE_ASSET__BSOXrDAg__"